<template>
  <footer class="site-footer">
    <div class="shell">
      <div class="site-footer__panel">
        <div class="site-footer__top">
          <div class="footer-brand">
            <span class="footer-brand__eyebrow">QINGZHUI EDUCATION</span>
            <h2>以长期主义陪伴家庭成长，做更有温度的教育品牌。</h2>
            <p>
              我们坚持“家校社共育”的教育视角，连接父母、孩子与导师，让成长既有方向，也有陪伴。
            </p>
          </div>

          <div class="footer-columns">
            <div class="footer-column">
              <span class="footer-column__title">快速入口</span>
              <router-link to="/business">业务体系</router-link>
              <router-link to="/team">师资团队</router-link>
              <router-link to="/job">人才招募</router-link>
              <router-link to="/we">联系我们</router-link>
            </div>

            <div class="footer-column">
              <span class="footer-column__title">联系信息</span>
              <span>邮箱：qzgjwh@126.com</span>
              <span>广州总部：番禺区南村镇汇智三路 ITC 国际科创中心</span>
            </div>

            <div class="footer-column">
              <span class="footer-column__title">关注我们</span>
              <div class="qr-grid">
                <div v-for="item in qrList" :key="item.label" class="qr-card">
                  <img :src="item.img" :alt="item.label" />
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="site-footer__bottom">
          <div class="site-footer__record">
            <span>法律声明</span>
            <span>统一社会信用代码：91440300MA5HAW1424</span>
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
              rel="noreferrer"
            >
              粤ICP备2022074093
            </a>
          </div>
          <p>
            Copyright © 2021 - 2026 青追国际文化发展（广州）有限公司. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "QingFooter",
  data() {
    return {
      qrList: [
        {
          label: "官方微信",
          img: "https://oss.qzgjwh.com/webapp/2023/weixin.png",
        },
        {
          label: "视频号",
          img: "https://oss.qzgjwh.com/webapp/2023/weixin.png",
        },
        {
          label: "小红书",
          img: "https://oss.qzgjwh.com/webapp/2023/xiaohongshu.png",
        },
        {
          label: "抖音",
          img: "https://oss.qzgjwh.com/webapp/2023/douyin.png",
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
.site-footer {
  width: 100%;
  padding: 0;
  background: linear-gradient(180deg, #2f4f90 0%, #243f74 100%);
}

.site-footer :deep(.shell) {
  width: 100%;
  max-width: none;
}

.site-footer :deep(.shell) {
  width: 100%;
  max-width: none;
}

.site-footer__panel {
  width: 100%;
  max-width: none;
  padding: 42px 32px 28px;
  border-radius: 0;
  background: linear-gradient(
      180deg,
      rgba(47, 79, 144, 0.98),
      rgba(36, 63, 116, 0.96)
    ),
    linear-gradient(135deg, rgba(240, 178, 79, 0.12), rgba(240, 178, 79, 0));
  color: rgba(248, 244, 237, 0.92);
  box-shadow: none;
}

.site-footer__top {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  gap: 40px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.footer-brand {
  max-width: 520px;
  text-align: left;

  &__eyebrow {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
  }

  h2 {
    margin: 18px 0 16px;
    font-size: clamp(28px, 3vw, 44px);
    line-height: 1.2;
  }

  p {
    color: rgba(248, 244, 237, 0.72);
  }
}

.footer-columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;

  a,
  span {
    color: rgba(248, 244, 237, 0.78);
    font-size: 14px;
    line-height: 1.8;
  }

  a:hover {
    color: #f7d7a9;
  }

  &__title {
    color: #f8f4ed;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }
}

.qr-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.qr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 14px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);

  img {
    width: 84px;
    height: 84px;
    border-radius: 14px;
    background: #fff;
    padding: 6px;
    object-fit: cover;
  }

  span {
    font-size: 13px;
  }
}

.site-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding-top: 24px;

  p {
    color: rgba(248, 244, 237, 0.64);
    font-size: 13px;
  }
}

.site-footer__record {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  text-align: left;

  span,
  a {
    color: rgba(248, 244, 237, 0.76);
    font-size: 13px;
  }

  a:hover {
    color: #f7d7a9;
  }
}

@media (max-width: 980px) {
  .site-footer__panel {
    padding: 28px 20px 24px;
  }

  .site-footer__top,
  .footer-columns,
  .site-footer__bottom {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-columns {
    width: 100%;
  }
}
</style>
